import logo from './logo.svg';
import './App.css';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/login';
import { Navigate, Route, Routes } from 'react-router';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from './context/Context';
import { useApiCall } from './custom-hooks/api-call';
import { Sidebar } from './component/Sidebar_v2';
import Agents from './pages/Agents';
import Teams from './pages/Teams';
import Units from './pages/Units';
import AgentDetailView from './pages/Agent-Detail';
import NewDashboard from './pages/NewDashboard';
import ManagementPage from './pages/Management';
import ProductPage from './pages/Products';
import OverviewPage from './pages/Overview';
import MainLoader from './component/MainLoader';

function App() {
  const {state, dispatch} = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 1024
  );

  // Auto-collapse the sidebar to its icon rail on iPad-width viewports (<1024px)
  // so the content area isn't cramped; the user can still expand it manually,
  // and that choice sticks until the next breakpoint-crossing resize/rotation.
  useEffect(() => {
    const mql = window.matchMedia("(max-width: 1023px)");
    const handleChange = (e) => setIsSidebarCollapsed(e.matches);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  const logout = () => {
    localStorage.removeItem("tokenSaleHub")
    localStorage.removeItem("userSaleHub");
    dispatch({type: "USER_LOGOUT"})
  }

  const checkUser = async() => {
    const userToken = localStorage.getItem("tokenSaleHub")
    if(!userToken){
      logout();
      return;
    }
    try {
      const apiRes = await apiCall({method: "get", url: "me", customToken: userToken})
      localStorage.setItem("userSaleHub", JSON.stringify(apiRes.user));
      dispatch({ type: 'USER_LOGIN', payload: apiRes.user, token: userToken });
      // console.log("Api Res", apiRes);
    } catch (error) {
      console.log("Err", error)
      logout();
    }
  }

  useEffect(() => {
    checkUser()
  }, [])

  return (
    <div className="App">
      {/* <Dashboard /> */}
      {state.isLogin == null ?
        <MainLoader />
        :
        (state.isLogin == true) ?
        <div className='flex w-[100vw] h-[100vh] overflow-hidden'>
          <Sidebar
            isCollapsed={isSidebarCollapsed}
            onToggleCollapse={() => setIsSidebarCollapsed((c) => !c)}
          />
          <div className="flex-1 w-[100%] h-[100%] overflow-auto">
            <Routes>
              <Route path='/overview' element={<OverviewPage />} />
              <Route path='/agents' element={<Agents />} />
              <Route path='/teams' element={<Teams />} />
              <Route path='/units' element={<Units />} />
              <Route path='/management' element={<ManagementPage />} />
              <Route path='/product' element={<ProductPage />} />
              <Route path='/new-dashboard' element={<NewDashboard />} />
              <Route path='/agent-detail/:id' element={<AgentDetailView />} />
              <Route path='*' element={<Navigate to={"/overview"} />} />
            </Routes>
          </div>
        </div>
        :
        <Routes>
          <Route path='/login' element={<LoginPage />} />
          <Route path='*' element={<Navigate to={"/login"} />} />
        </Routes>
      }
      {/* <LoginPage /> */}
    </div>
  );
}

export default App;
